import { render, staticRenderFns } from "./OrdersProfitByPosition.vue?vue&type=template&id=e5589ad4&"
import script from "./OrdersProfitByPosition.vue?vue&type=script&lang=js&"
export * from "./OrdersProfitByPosition.vue?vue&type=script&lang=js&"
import style0 from "./OrdersProfitByPosition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VSpacer})
